import { AxiosResponse } from 'axios';

import { ORDERS_SEARCH_FILTERS } from '../../types';

import { PaginationResponse } from './dto/BaseApi';
import {
  IOrdersChangedResponse,
  NameLabelResponse,
  OrderItemResponse,
  SearchOrdersResponse,
} from './dto/SearchOrders';
import BaseApi from './BaseApi';

const ordersApi = {
  getOrders(
    token: string,
    filters: ORDERS_SEARCH_FILTERS
  ): Promise<AxiosResponse<PaginationResponse<SearchOrdersResponse[]>>> {
    return BaseApi.post('/api/v1/orders/search', filters);
  },

  getIdOrder(
    token: string,
    orderId: number,
    accountId: number
  ): Promise<AxiosResponse<SearchOrdersResponse>> {
    return BaseApi.get(`/api/v1/orders/${orderId}?accountId=${accountId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },

  getOrderItemPositions(
    token: string,
    accountId: number,
    orderId: number,
    itemId: number
  ): Promise<AxiosResponse<OrderItemResponse>> {
    return BaseApi.get(
      `/api/v1/orders/${orderId}/items/${itemId}?accountId=${accountId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  },

  getRoles(token: string): Promise<AxiosResponse<NameLabelResponse[]>> {
    return BaseApi.post('/api/v1/orders/search-roles');
  },

  getOrderStatuses(token: string): Promise<AxiosResponse<NameLabelResponse[]>> {
    return BaseApi.post('/api/v1/orders/statuses');
  },

  getOrderRealizationStatuses(
    token: string
  ): Promise<AxiosResponse<NameLabelResponse[]>> {
    return BaseApi.post('/api/v1/orders/items/statuses');
  },

  getOrdersChanges(
    count: number
  ): Promise<AxiosResponse<IOrdersChangedResponse>> {
    return BaseApi.get(`/api/v1/orders/changes?count=${count}`);
  },
};

export default ordersApi;
